export default __webpack_public_path__ + "static/media/icon-logo.5e26f2ee.svg";